module.exports = __webpack_public_path__ + "static/img/banner.a9004c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/banner.jpg
// module id = C+bJ
// module chunks = 0